import { CanvasHandler } from "../../../handlers";
import { RoundTablePropertiesEnum, ObjectSuperTypesEnum, ObjectTypesEnum } from "../../../enums";
import store from "../../../redux/store";
import { TablePropertiesBase } from "./TablePropertiesBase";
import { RoundTableSeatHelper } from "../helpers/RoundTableSeatHelper";

class RoundTableProperties extends TablePropertiesBase {
    public handlers: any;
    private readonly SEAT_RADIUS = 7.5;
    private readonly SEAT_GAP = 10;
  
    constructor(canvasHandler: CanvasHandler) {
        super(canvasHandler)
        this.canvasHandler = canvasHandler;
        this.handlers = {
            [RoundTablePropertiesEnum.SelectionType]: this.updateSelectionType,
            [RoundTablePropertiesEnum.Category]: this.updateCategory,
            [RoundTablePropertiesEnum.SeatsQuantity]: this.updateSeatsQuantity,
            [RoundTablePropertiesEnum.EmptySpacesQuantity]: this.updateEmptySpacesQuantity,
            [RoundTablePropertiesEnum.Radius]: this.updateRadius,
            [RoundTablePropertiesEnum.SectionLabel]: this.updateSectionLabel,
            [RoundTablePropertiesEnum.TableLabelingVisible]: this.updateLabelVisibility,
            [RoundTablePropertiesEnum.TableLabelingLabel]: this.updateTableLabel,
            [RoundTablePropertiesEnum.TableLabelingDisplayedLabel]: this.updateTableDisplayedLabel,
            [RoundTablePropertiesEnum.SeatLabelingType]: this.updateSeatLabelingDistribution,
            [RoundTablePropertiesEnum.SeatLabelingStartsAt]: this.updateSeatLabelingStartsAt,
        }
    }

    public updateProperties = (
        selectedItem: any,
        key: string, 
        value: any, 
        allValues: any, 
    ) => {
        const handler = this.handlers[key];
        const state = store.getState();
        const { properties: { categories } } = state;
        const tableGroup = selectedItem.getObjects().find((obj: any) => obj.superType === ObjectSuperTypesEnum.Table);
        const table = tableGroup?.getObjects(ObjectTypesEnum.Circle)[0];
        const tableText = tableGroup?.getObjects(ObjectTypesEnum.Text)[0];
        const seats = selectedItem.getObjects().filter((obj: any) => obj.superType === ObjectSuperTypesEnum.Seat);
        const selectedCategory: any = categories.find((category: any) => category.key === value) ?? null;

        if (!handler) {
            console.warn(`No handler for property: ${key}`);
            return;
        }

        handler.call(this, {
            value,
            allValues,
            selectedItem,
            table,
            tableGroup,
            tableText,
            seats,
            selectedCategory
        });
        this.canvasHandler.canvas.requestRenderAll();
    };

    private updateSeatsQuantity = async ({value, selectedItem, table, tableGroup} : any) => {
        if(value == 1){
            selectedItem.set({
                emptySpaces: 0
            })
        }
        selectedItem.set({
            maxEmptySpaces: RoundTableSeatHelper.calculateMaxEmptySpaces(value, selectedItem.maxSeats)
        })
        await RoundTableSeatHelper.rebuildSeats({
            roundTable: selectedItem,
            table,
            tableGroup,
            seatsQuantity: value,
            seatRadius: this.SEAT_RADIUS,
            seatGap: this.SEAT_GAP,
            setSeatValue: this.setSeatValue,
        });
    }

    private updateEmptySpacesQuantity = async ({ value, selectedItem, tableGroup, table }: any) => {
        selectedItem.set({
            emptySpaces: value,
            maxEmptySpaces: RoundTableSeatHelper.calculateMaxEmptySpaces(selectedItem.seatsQuantity, selectedItem.maxSeats)
        });
        await RoundTableSeatHelper.rebuildSeats({
            roundTable: selectedItem,
            table,
            tableGroup,
            seatsQuantity: selectedItem.seatsQuantity,
            seatRadius: 7.5,
            seatGap: this.SEAT_GAP,
            setSeatValue: this.setSeatValue,
        });
    };

    private updateRadius = async ({value, selectedItem, table, tableGroup} : any) => {
        table.set({
            radius: value
        });
        await RoundTableSeatHelper.rebuildSeats({
            roundTable: selectedItem,
            table,
            tableGroup,
            seatsQuantity: selectedItem.seatsQuantity,
            seatRadius: 7.5,
            seatGap: this.SEAT_GAP,
            setSeatValue: this.setSeatValue,
        });
    }

    protected getOrderedTableSeats = ({ seats, table }: any) => {
        return RoundTableSeatHelper.getOrderedTableSeats({ seats, table });
    };
}
    

export default RoundTableProperties;